// extracted by mini-css-extract-plugin
export default {"dotsDropdown":"HeaderDotsMenu_dotsDropdown__8d7Up"};